export const bookingConfig = {
	capacities: [
		{ label: '1-4', value: '1-4' },
		{ label: '4-8', value: '4-8' },
		{ label: '8-12', value: '8-12' },
		{ label: '12-16', value: '12-16' },
		{ label: '16+', value: '16-' },
	],
	earlyRebate: {
		code: 'promotion.early_booking',
		days: 30,
		percent: 10,
	},
	hours: { max: 23, min: 8 },
	months: 12,
	recurring: {
		config: {
			maxDays: 2,
			minDays: 1,
		},
		offers: [
			{
				billedHours: 8,
				daysPerWeek: 1,
				rebate: 0.6,
			},
			{
				billedHours: 8,
				daysPerWeek: 2,
				rebate: 0.65,
			},
		],
		typeformRecurringBookingURL: {
			pricingSection: 'https://cocoonspace.typeform.com/to/updKKFB7',
			sidebar: 'https://cocoonspace.typeform.com/to/mjSNTPuw',
		},
	},
	warningTimeout: 5,
	weekDailyHours: 8,
	weekendDailyHours: 6,
} as const

export const BOOKING_CONFIG = bookingConfig
